<template>
  <b-modal :id="id"
           centered
           :title="title"
           ok-title="Save"
           size="xl"
           @ok="updateRole"
           @cancel="$emit('cancel')">
    <b-form>
      <b-form-group  label="Name: "
                     label-for="edit-role__name">
        <b-form-input id="edit-role__name"
                       type="text"
                       v-model="roleToEdit.name"
                       required
                       :placeholder="roleToEdit.name">
        </b-form-input>
      </b-form-group>
      <b-form-group  label="Resources: "
                     label-for="edit-role__resources">
        <b-form-group v-for="(permission, index) in permissions" :label="permission.resource.name"
          :key="index">
          <b-form-radio-group v-model="permission.operation" :options="resourceOptions"/>
        </b-form-group>
      </b-form-group>
     </b-form>
  </b-modal>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import { constants } from '@shared/_services/constants'

export default {
  name: 'EditModalRole',
  props: {
    id: String,
    title: String,
    roleToEdit: Object,
  },
  computed: {
    ...mapState('resourcesManagement', ['resources']),

    resourceOptions () {
      let resourceOptions = [];
      constants.accessRights.forEach(el => {
        let tmp = {};
        tmp.text = el;
        tmp.value = el;
        resourceOptions.push(tmp)
      });
      return resourceOptions
    },
    roleToEditIsSet () {
      // TODO refactor
      return !(this.roleToEdit.name === '' && this.roleToEdit.permissions === '' &&
              this.roleToEdit.id === 'id');

    },
    permissions () {
      let permissions = [];
      if (!this.resources || !this.roleToEditIsSet) { // TODO
        return permissions
      }
      this.resources.forEach(el => {
        let tmp = {};
        tmp.resource = el;
        let permission = null;
        if (this.roleToEdit.permissions) {
          permission = this.roleToEdit.permissions.find(permission => {
            return Number(permission.resource.id) === Number(el.id)})
        }

        tmp.operation = permission ? permission.operation : constants.defaultAccessRight;
        permissions.push(tmp)
      });
      return permissions
    }
  },
  methods: {
    updateRole () {
      this.roleToEdit.permissions = this.permissions;
      this.$emit('ok')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>